export const listaLogradouroStore = {
    namespaced: true,
    state : {
        ListaLogradouro: {},
    },
    mutations : {
        updateStateListaLogradouro(state, payload) {
            state.ListaLogradouro = payload;
        },
    },
    actions : {
        updateStateListaLogradouro({ state, commit }, data) {
            commit('updateStateListaLogradouro', data);
        },
    },
    getters : {
        ListaLogradouro: (state, getters) => {
            return state.ListaLogradouro;
        },   
    }
}